import { render, staticRenderFns } from "./AddVillagePage.vue?vue&type=template&id=2d27467a&"
import script from "./AddVillagePage.vue?vue&type=script&lang=js&"
export * from "./AddVillagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports